function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M349.03 141.226v66.579a9.078 9.078 0 01-9.079 9.079H9.079A9.08 9.08 0 010 207.805v-66.579a9.08 9.08 0 019.079-9.079h330.872a9.076 9.076 0 019.079 9.079z"
});

function SvgMinusSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 349.03 349.03"
  }, props), _ref);
}

export default SvgMinusSolid;